export default {
  // Thank-You
  thankYou: {
    english: "Thank You",
    spanish: "Gracias",
  },
  // goBack used in error-page
};
